<template>
  <div>
    <div class="images-container">
      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        label-width="110px"
        style="height: 50px;"
      >
        <el-row>
          <el-col :span="7">
            <el-form-item
              size="small"
              :label="'期望到货日期'"
              prop="expectedDeliveryDate"
            >
              <el-date-picker
                v-model="formData.expectedDeliveryDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item
              size="small"
              :label="$l('INDEX.choose_fabric_agent') || '需求人'"
              prop="demandPersonCode"
            >
              <dict-select
                clearable
                v-model="formData.demandPersonCode"
                :selectedLabel.sync="formData.demandPersonName"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                size="small"
                url="/master/common/dict/baseUserSelect"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item
              size="small"
              prop="resCustCode"
              :label="$l('INDEX.label_customer') || '客户'"
            >
              <dict-select
                clearable
                v-model="formData.resCustCode"
                filterable
                size="small"
                url="/master/common/dict/customerSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_a_customer') ||
                    '请选择客户'
                "
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <vxe-grid
        auto-resize
        highlight-hover-row
        :toolbar-config="tableToolbar"
        :data="tableData"
        :columns="tableColumns"
        :loading="loading"
        size="small"
        :seq-config="{
          startIndex: 0,
        }"
        resizable
        border
        ref="table"
        :edit-config="{ enabled: true, trigger: 'click', mode: 'row' }"
      >
        <template v-slot:fabricImg="{ row, rowIndex }">
          <el-image
            class="viewImage"
            :preview-src-list="imgUriList"
            :initial-index="rowIndex"
            :src="
              row.thumbImageUrl
                ? $osscdn(row.thumbImageUrl)
                : '/image/static/img/nopic.jpg'
            "
          />
        </template>
        <template v-slot:fabricColor="{ row }">
          {{ '颜色' }}：{{ row.colorName }}
          <br />
          {{ '编号' }}：{{ row.scmColorNo }}
        </template>
        <template v-slot:demandAmount="{ row }">
          {{ format(demandAmount(row)) }}
        </template>
        <template v-slot:opt="{ row }">
          <div>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$l('INDEX.btn_tips_del') || 删除"
              placement="top"
            >
              <i class="el-icon-delete tool-btn" @click="del(row)"></i>
            </el-tooltip>
          </div>
        </template>
        <template v-slot:empty="{}">
          <div style="text-align: center">
            <img src="/image/static/img/nodata.png" />
            <p class="no-data">
              {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
            </p>
          </div>
        </template>
      </vxe-grid>
    </div>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import { multiply, format } from '@/libs/util.number.js'
export default {
  mixins: [EditLoading],
  props: {
    title: {
      type: String,
      default: '图片维护',
    },
  },
  data() {
    return {
      tableData: [],
      tableToolbar: {},
      formData: {
        expectedDeliveryDate: '',
        resCustCode: '',
        demandPersonCode: '',
        demandPersonName: '',
      },
      loading: false,
      tableColumns: tableColumns(this),
      format: (number) => format(number),
      rules: {
        expectedDeliveryDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        demandPersonCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择',
            trigger: 'change',
          },
        ],
        resCustCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    demandAmount() {
      return (row) => {
        if (row.demandQty) {
          return multiply(row.demandQty, row.unitPrice)
        }
        return 0
      }
    },
    imgUriList() {
      return this.tableData.map((e) => e.imageUrl)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getFormData() {
      let tmpData = undefined
      this.$refs['form'].validate((valid) => {
        if (valid) {
          tmpData = { ...this.formData }
          tmpData['detailList'] = this.tableData
          return tmpData
        } else {
          return
        }
      })
      return tmpData
    },
    getData() {
      this.$api.resFabricDemandDetailCartListApi().then((res) => {
        this.tableData = res.body.data || []
      })
    },
    del(row) {
      let index = this.$refs.table.getRowIndex(row)
      this.$api.resFabricDemandDetailDelApi({ ...row }).then((res) => {
        const { status } = res
        if (status == 200) {
          this.tableData.splice(index, 1)
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.images-container {
  min-height: 302px;
}

.el-form-item {
  margin-bottom: 0px;
}

.side-frame-success {
  padding: 1px 5px 0 5px;
  border-left: 3px solid $color-primary;
  height: 26px;
}

.image-box {
  width: 150px;
  height: 100px;
  position: relative;
  background-color: #fbfdff;
  position: relative;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-box:hover {
  .shadow {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}

.shadow {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  padding: 2px;
}
.viewImage {
  width: 100px;
  height: 80px;
}
</style>
